import styled from 'styled-components'

export const CardHeaderText = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;

  /* identical to box height, or 150% */

  /* Global/08. Dark */
  color: #343a40;
`

export const CardValueText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;

  /* identical to box height, or 120% */
  display: flex;
  align-items: center;

  /* Text/01. Body */
  color: #212529;
`

export const CardDescriptionText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;

  /* identical to box height */
  display: flex;
  align-items: center;

  /* Text/02. Muted */
  color: #6c757d;

  white-space: nowrap;
`
